<template>
  <div>
    <Header />
    <div class="min-h-screen bg-slate-50 p-4 md:p-8 text-slate-800 font-sans">
      <div class="max-w-[1200px] mx-auto space-y-6">
        <div>
          <div class="flex items-center gap-2 text-sm">
            <router-link
              to="/student-list"
              class="text-gray-500 hover:text-blue-600 transition"
            >
              Student
            </router-link>

            <svg
              class="w-4 h-4 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>

            <span class="font-medium text-gray-800">
              {{ pageTitle }}
            </span>
          </div>
        </div>
        <div
          class="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden"
        >
          <div class="h-44 bg-gradient-to-r from-blue-600 to-sky-400"></div>

          <div
            class="px-6 pb-6 relative flex flex-col sm:flex-row sm:items-end justify-between gap-4"
          >
            <div
              class="flex flex-col sm:flex-row items-center sm:items-end gap-4 -mt-16 sm:-mt-12"
            >
              <div
                class="w-28 h-28 rounded-full overflow-hidden border-4 border-white shadow-md bg-blue-600 flex items-center justify-center"
              >
                <img
                  v-if="Students.profile && Students.profile !== 'None'"
                  :src="Students.profile"
                  alt="Profile"
                  class="w-full h-full object-cover"
                  @error="Students.profile = null"
                />

                <span v-else class="text-white text-3xl font-bold uppercase">
                  {{
                    (Students.user || "NA")
                      .split(" ")
                      .map((n) => n[0])
                      .join("")
                      .substring(0, 2)
                      .toUpperCase()
                  }}
                </span>
              </div>
              <div class="text-center sm:text-left">
                <!-- Name and Verification -->
                <div
                  class="flex flex-col sm:flex-row items-center sm:items-center sm:justify-start gap-2"
                >
                  <h1 class="text-2xl font-bold text-slate-900 capitalize">
                    {{ Students.user !== "None" ? Students.user : "N/A" }}
                  </h1>

                  <span
                    v-if="Students.verified"
                    class="inline-flex items-center gap-1 bg-green-50 text-green-700 text-xs px-3 py-1 rounded-full font-medium border border-green-200"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="w-3.5 h-3.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    Verified
                  </span>
                </div>

                <!-- Program / Semester / Batch -->
                <div
                  class="flex flex-wrap justify-center sm:justify-start gap-2 mt-1"
                >
                  <span
                    class="px-3 py-1 text-xs font-medium bg-slate-100 text-slate-700 rounded-full"
                  >
                    {{ Students.program !== "None" ? Students.program : "N/A" }}
                  </span>

                  <span
                    class="px-3 py-1 text-xs font-medium bg-blue-100 text-blue-700 rounded-full"
                  >
                    Semester
                    {{
                      Students.semester !== "None" ? Students.semester : "N/A"
                    }}
                  </span>

                  <span
                    class="px-3 py-1 text-xs font-medium bg-emerald-100 text-emerald-700 rounded-full"
                  >
                    Batch
                    {{ Students.batch !== "None" ? Students.batch : "N/A" }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="border-t border-slate-100 bg-slate-50/50 px-6 py-3.5 flex flex-wrap gap-x-6 gap-y-2 text-sm text-slate-600"
          >
            <div class="flex items-center gap-2">
              <svg
                class="w-3.5 h-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>

              {{ Students.Email !== "None" ? Students.Email : "N/A" }}
            </div>
            <div class="flex items-center gap-2">
              <svg
                class="w-3.5 h-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>

              {{ Students.mobile !== "None" ? Students.mobile : "N/A" }}
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div
            class="bg-white rounded-2xl p-5 shadow-sm border border-slate-100 flex flex-col justify-between"
          >
            <div>
              <h2 class="text-sm font-medium text-slate-900 mb-3">
                Personal Information
              </h2>

              <div class="divide-y divide-slate-100 text-xs">
                <div class="py-3 flex justify-between items-center gap-4">
                  <span class="text-slate-500">PRN Number</span>
                  <span class="font-medium text-slate-800">
                    {{
                      Students.prn_number !== "None"
                        ? Students.prn_number
                        : "N/A"
                    }}
                  </span>
                </div>

                <div class="py-3 flex justify-between items-center gap-4">
                  <span class="text-slate-500">Batch</span>
                  <span class="font-medium text-slate-800">
                    {{ Students.batch !== "None" ? Students.batch : "N/A" }}
                  </span>
                </div>

                <div class="py-3 flex justify-between items-center gap-4">
                  <span class="text-slate-500">Program</span>
                  <span class="font-medium text-slate-800">
                    {{ Students.program !== "None" ? Students.program : "N/A" }}
                  </span>
                </div>

                <div class="py-3 flex justify-between items-center gap-4">
                  <span class="text-slate-500">Semester</span>
                  <span class="font-medium text-slate-800">
                    {{
                      Students.semester !== "None" ? Students.semester : "N/A"
                    }}
                  </span>
                </div>

                <div class="py-3 flex justify-between items-center gap-4">
                  <span class="text-slate-500">Joined</span>
                  <span class="font-medium text-slate-800">
                    {{ formatDate(Students.created_at) }}
                  </span>
                </div>

                <div class="py-3 flex justify-between items-center gap-4">
                  <span class="text-slate-500">Email</span>
                  <span
                    class="font-medium text-slate-800 truncate max-w-[160px]"
                    :title="Students.Email"
                  >
                    {{ Students.Email !== "None" ? Students.Email : "N/A" }}
                  </span>
                </div>

                <div class="py-3 flex justify-between items-center gap-4">
                  <span class="text-slate-500">Phone</span>
                  <span class="font-medium text-slate-800">
                    {{ Students.mobile !== "None" ? Students.mobile : "N/A" }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="lg:col-span-2 bg-white rounded-2xl p-6 shadow-sm border border-slate-100"
          >
            <div class="flex justify-between items-center mb-6">
              <h2 class="text-sm font-medium text-slate-900">
                Performance analytics
              </h2>

              <span
                class="bg-slate-100 text-slate-700 text-xs font-semibold px-3 py-1 rounded-lg border border-slate-200"
              >
                Last 30 days
              </span>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-5 gap-6 items-center">
              <!-- Radar Chart -->
              <div
                class="md:col-span-3 h-64 flex items-center justify-center relative"
              >
                <Radar :data="chartData" :options="chartOptions" />
              </div>

              <!-- Progress Bars -->
              <div class="md:col-span-2 space-y-4">
                <div
                  v-for="(val, label) in performanceMetrics"
                  :key="label"
                  class="space-y-1.5"
                >
                  <div
                    class="flex justify-between text-xs font-semibold text-slate-700"
                  >
                    <span>
                      {{ capitalizeFirst(label) }}
                    </span>

                    <span> {{ val }}% </span>
                  </div>

                  <div
                    class="w-full h-2 bg-slate-100 rounded-full overflow-hidden"
                  >
                    <div
                      class="h-full bg-blue-500 rounded-full"
                      :style="{ width: val + '%' }"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-2xl shadow-sm p-5">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-sm font-semibold text-gray-800">
              Enrolled courses
            </h2>

            <router-link
              v-if="student_id && student_sem && student_dep && token"
              :to="{
                name: 'UserCourse',
                params: {
                  studentid: encodeValue(student_id),
                  studentsem: encodeValue(student_sem),
                  studentdep: encodeValue(student_dep),
                  tokens: encodeValue(token),
                },
              }"
              class="text-xs text-blue-500 hover:underline font-medium"
            >
              View All
            </router-link>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            <div
              v-for="course in courses.slice(0, 6)"
              :key="course"
              class="flex items-center gap-3 p-3 rounded-xl border border-gray-100 hover:border-blue-100 hover:bg-blue-50/30 transition cursor-pointer"
            >
              <img
                :src="course.thumbnail"
                :alt="course.title"
                class="w-14 h-14 rounded-lg object-cover border"
              />
              <div class="flex-1 min-w-0">
                <p class="text-xs font-semibold text-gray-800 truncate">
                  {{ course.title }}
                </p>
                <div
                  class="mt-1.5 h-1.5 bg-gray-100 rounded-full overflow-hidden"
                >
                  <div
                    class="h-full bg-blue-500 rounded-full transition-all duration-700"
                    :style="{ width: course.progress + '%' }"
                  ></div>
                </div>
                <p class="text-xs text-gray-400 mt-1">
                  {{ course.progress }}% complete
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Radar } from "vue-chartjs";
import Header from "@/components/Admin/Header.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
);

export default {
  name: "UserView",
  components: { Radar, Header },
  data() {
    return {
      performanceMetrics: {
        quizzes: 86,
        assignments: 78,
        projects: 92,
        attendance: 95,
        participation: 71,
      },

      Students: [],
      courses: [],
      student_id: "",
      student_sem: "",
      student_dep: "",
      token: "",
    };
  },
  mounted() {
    this.student_id = window.atob(this.$route.params.student_id);
    this.student_sem = window.atob(this.$route.params.student_sem);
    this.student_dep = window.atob(this.$route.params.student_dep);
    this.token = window.atob(this.$route.params.token);
    this.getstudentprofile();
    this.getcourses();
  },
  created() {},
  computed: {
    ...mapGetters(["userInfo"]),
    pageTitle() {
      const routeNames = {
        UserView: "Student Profile",
      };

      return routeNames[this.$route.name] || "Page";
    },
    personalInfo() {
      return [
        { label: "Roll number", value: "AUO-MBA-2026-118" },
        { label: "Program", value: "MBA — Semester I" },
        { label: "Batch", value: "Batch 2026 · MBA Online" },
        { label: "Joined", value: "Aug 2025" },
        { label: "Email", value: this.student.email },
        { label: "Phone", value: this.student.phone },
      ];
    },
    chartData() {
      return {
        labels: [
          "Quizzes",
          "Assignments",
          "Projects",
          "Attendance",
          "Participation",
        ],

        datasets: [
          {
            label: "Performance",
            data: [
              this.performanceMetrics.quizzes,
              this.performanceMetrics.assignments,
              this.performanceMetrics.projects,
              this.performanceMetrics.attendance,
              this.performanceMetrics.participation,
            ],
            backgroundColor: "rgba(59,130,246,0.15)",
            borderColor: "#0088f2",
            borderWidth: 1,
            pointRadius: 4,
            pointHoverRadius: 6,
            pointBackgroundColor: "#0088f2",
            pointHoverBackgroundColor: "#0088f2",
            pointBorderColor: "#ffffff",
            pointHoverBorderColor: "#0088f2",
            pointBorderWidth: 1,
            fill: true,
          },
        ],
      };
    },

    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,

        interaction: {
          mode: "nearest",
          intersect: true,
        },

        plugins: {
          legend: {
            display: false,
          },

          tooltip: {
            enabled: true,
            backgroundColor: "#ffffff",
            titleColor: "#0088f2",
            bodyColor: "#2563eb",
            borderColor: "#e2e8f0",
            borderWidth: 1,
            padding: 10,
            cornerRadius: 10,
            displayColors: false,
            caretSize: 6,
            caretPadding: 0,
            xAlign: "center",
            yAlign: "bottom",

            titleFont: {
              size: 13,
              weight: "500",
            },

            bodyFont: {
              size: 12,
              weight: "500",
            },

            callbacks: {
              title(context) {
                return context[0].label;
              },
              label(context) {
                return "score : " + context.raw;
              },
            },
          },
        },

        scales: {
          r: {
            min: 0,
            max: 100,

            angleLines: {
              color: "#e2e8f0",
            },

            grid: {
              color: "#cbd5e1",
              circular: false,
            },

            pointLabels: {
              color: "#64748b",
              font: {
                size: 11,
                weight: "500",
              },
            },

            ticks: {
              display: true,
              stepSize: 25,
              color: "#94a3b8",
              backdropColor: "transparent",
              font: {
                size: 9,
              },
            },
          },
        },

        elements: {
          point: {
            radius: 4,
            hoverRadius: 8,
            hitRadius: 20,
            borderWidth: 2,
          },
        },
      };
    },
  },
  methods: {
    encodeValue(value) {
      return window.btoa(String(value));
    },
    capitalizeFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    async getstudentprofile() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/profile_detail/?Key=${this.token}`,
        );

        if (res.data) {
          this.Students = res.data.data;
        } else {
          this.Students = [];
        }
      } catch (err) {
        console.error("Error fetching student profile:", err);
        this.Students = [];
      }
    },
    formatDate(date) {
      if (!date) return "N/A";

      return new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    async getcourses() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/student-semester-get/${this.student_id}/?Key=${this.token}&semester__id=${this.student_sem}`,
        );

        if (response.data.data.status === 200) {
          const semesterData = response.data.data.data[0].semester[0];

          this.courses = semesterData.course
            .filter((course) => course.published_course?.published === true)
            .map((course) => ({
              ...course,
              progress: Math.floor(Math.random() * 100) + 1,
            }));
        } else {
          this.courses = [];
        }
      } catch (err) {
        console.error("Error fetching courses:", err);
        this.courses = [];
      }
    },
  },
};
</script>
